// src/app/redux/actions/parcoursActions.js

// ========================================
// 🎯 ACTION TYPES
// ========================================

export const FETCH_PARCOURS_REQUEST = 'FETCH_PARCOURS_REQUEST';
export const FETCH_PARCOURS_SUCCESS = 'FETCH_PARCOURS_SUCCESS';
export const FETCH_PARCOURS_FAIL = 'FETCH_PARCOURS_FAIL';

export const GET_PARCOURS_BY_ID_REQUEST = 'GET_PARCOURS_BY_ID_REQUEST';
export const GET_PARCOURS_BY_ID_SUCCESS = 'GET_PARCOURS_BY_ID_SUCCESS';
export const GET_PARCOURS_BY_ID_FAIL = 'GET_PARCOURS_BY_ID_FAIL';

export const CREATE_PARCOURS_REQUEST = 'CREATE_PARCOURS_REQUEST';
export const CREATE_PARCOURS_SUCCESS = 'CREATE_PARCOURS_SUCCESS';
export const CREATE_PARCOURS_FAIL = 'CREATE_PARCOURS_FAIL';

export const UPDATE_PARCOURS_REQUEST = 'UPDATE_PARCOURS_REQUEST';
export const UPDATE_PARCOURS_SUCCESS = 'UPDATE_PARCOURS_SUCCESS';
export const UPDATE_PARCOURS_FAIL = 'UPDATE_PARCOURS_FAIL';

export const DELETE_PARCOURS_REQUEST = 'DELETE_PARCOURS_REQUEST';
export const DELETE_PARCOURS_SUCCESS = 'DELETE_PARCOURS_SUCCESS';
export const DELETE_PARCOURS_FAIL = 'DELETE_PARCOURS_FAIL';

export const ASSIGN_PARCOURS_TO_POSTES_REQUEST = 'ASSIGN_PARCOURS_TO_POSTES_REQUEST';
export const ASSIGN_PARCOURS_TO_POSTES_SUCCESS = 'ASSIGN_PARCOURS_TO_POSTES_SUCCESS';
export const ASSIGN_PARCOURS_TO_POSTES_FAIL = 'ASSIGN_PARCOURS_TO_POSTES_FAIL';

export const ASSIGN_PARCOURS_TO_UTILISATEURS_REQUEST = 'ASSIGN_PARCOURS_TO_UTILISATEURS_REQUEST';
export const ASSIGN_PARCOURS_TO_UTILISATEURS_SUCCESS = 'ASSIGN_PARCOURS_TO_UTILISATEURS_SUCCESS';
export const ASSIGN_PARCOURS_TO_UTILISATEURS_FAIL = 'ASSIGN_PARCOURS_TO_UTILISATEURS_FAIL';

// ========================================
// 🎬 ACTION CREATORS
// ========================================

export const fetchParcoursRequest = () => ({
    type: FETCH_PARCOURS_REQUEST,
});

export const fetchParcoursSuccess = (parcours) => ({
    type: FETCH_PARCOURS_SUCCESS,
    payload: parcours,
});

export const fetchParcoursFail = (error) => ({
    type: FETCH_PARCOURS_FAIL,
    payload: error,
});

export const getParcoursByIdRequest = (id) => ({
    type: GET_PARCOURS_BY_ID_REQUEST,
    payload: id,
});

export const getParcoursByIdSuccess = (parcours) => ({
    type: GET_PARCOURS_BY_ID_SUCCESS,
    payload: parcours,
});

export const getParcoursByIdFail = (error) => ({
    type: GET_PARCOURS_BY_ID_FAIL,
    payload: error,
});

export const createParcoursRequest = (parcoursData) => ({
    type: CREATE_PARCOURS_REQUEST,
    payload: parcoursData,
});

export const createParcoursSuccess = (parcours) => ({
    type: CREATE_PARCOURS_SUCCESS,
    payload: parcours,
});

export const createParcoursFail = (error) => ({
    type: CREATE_PARCOURS_FAIL,
    payload: error,
});

export const updateParcoursRequest = (id, parcoursData) => ({
    type: UPDATE_PARCOURS_REQUEST,
    payload: { id, parcoursData },
});

export const updateParcoursSuccess = (parcours) => ({
    type: UPDATE_PARCOURS_SUCCESS,
    payload: parcours,
});

export const updateParcoursFail = (error) => ({
    type: UPDATE_PARCOURS_FAIL,
    payload: error,
});

export const deleteParcoursRequest = (id) => ({
    type: DELETE_PARCOURS_REQUEST,
    payload: id,
});

export const deleteParcoursSuccess = (id) => ({
    type: DELETE_PARCOURS_SUCCESS,
    payload: id,
});

export const deleteParcoursFail = (error) => ({
    type: DELETE_PARCOURS_FAIL,
    payload: error,
});

export const assignParcoursToPostesRequest = (parcoursId, posteIds) => ({
    type: ASSIGN_PARCOURS_TO_POSTES_REQUEST,
    payload: { parcoursId, posteIds },
});

export const assignParcoursToPostesSuccess = () => ({
    type: ASSIGN_PARCOURS_TO_POSTES_SUCCESS,
});

export const assignParcoursToPostesFail = (error) => ({
    type: ASSIGN_PARCOURS_TO_POSTES_FAIL,
    payload: error,
});

export const assignParcoursToUtilisateursRequest = (parcoursId, utilisateurIds) => ({
    type: ASSIGN_PARCOURS_TO_UTILISATEURS_REQUEST,
    payload: { parcoursId, utilisateurIds },
});

export const assignParcoursToUtilisateursSuccess = () => ({
    type: ASSIGN_PARCOURS_TO_UTILISATEURS_SUCCESS,
});

export const assignParcoursToUtilisateursFail = (error) => ({
    type: ASSIGN_PARCOURS_TO_UTILISATEURS_FAIL,
    payload: error,
});
